export const TABLE_LIMIT = {
    simple: [10, 20, 50, 100],
    nested: [50, 100, 150, 200],
};

export type TableAllClasses = {
    table?: string;
    header?: string;
    headerCell?: string;
    resizeHandle?: string;
    body?: string;
    row?: string;
    rowCell?: string;
    selectedRow?: string;
};

export const TABLE_DEFAULT_STYLES: TableAllClasses = {
    table: '',
    header: 'h-11 flex bg-zinc-50 border-b border-zinc-200/70 text-[10.5px] font-semibold uppercase tracking-[0.12em] text-zinc-500',
    headerCell: 'flex items-center justify-between h-full px-5 whitespace-nowrap',
    resizeHandle: 'h-full w-px bg-zinc-200/70',
    body: 'bg-twComponentBackground',
    row: 'flex items-center border-b border-zinc-100 transition-colors duration-200 ease-out-expo hover:bg-zinc-50/70',
    rowCell: 'flex h-12 w-full items-center px-5 text-[13px] text-zinc-700',
    selectedRow: 'bg-primary-50/70',
};

export const PAGE_DIRECTION = {
    next: 'NEXT',
    prev: 'PREV',
} as const;
export type PageDirection = (typeof PAGE_DIRECTION)[keyof typeof PAGE_DIRECTION];
